const clientEnv = process.env.CLIENT_ENV || "production";
const googleMapsApiKey = process.env.GOOGLE_MAPS_API_KEY;

if (clientEnv === "development") {
  console.warn("Client debug mode enabled!");
}

export default {
  clientEnv,
  isJsTest: navigator.userAgent.includes("jsdom"),
  defaultOrderUnitType: "Standard",
  orderMaxAmountPerOrderItem: 100000,
  // To generate this array of supported countries you can use this command:
  // eslint-disable-next-line max-len
  // bin/rails r 'puts Foodstarter::Countries::ALLOWED_COUNTRY_CODES_FOR_PHONE_NUMBERS.map(&:downcase).sort.inspect'
  supportedCountries: [
    "at",
    "be",
    "bg",
    "ch",
    "cy",
    "cz",
    "de",
    "dk",
    "ee",
    "es",
    "fi",
    "fr",
    "gb",
    "gr",
    "hr",
    "hu",
    "ie",
    "it",
    "lt",
    "lu",
    "lv",
    "mt",
    "nl",
    "pl",
    "pt",
    "ro",
    "se",
    "si",
    "sk",
  ],
  formLabelColumnCount: 4,
  formInputColumnCount: 8,
  googleMapsApiKey,
};
